import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(TextInputComponent)]
})
export class TextInputComponent extends InputComponent implements OnInit {

  @Input() type?: InputOptions = InputOptions.TEXT;
  @Input() spellcheck = true;
  @Input() showWordCount = false;
  @Output() keyup: EventEmitter<void> = new EventEmitter<void>();

  constructor() { super(); }

  ngOnInit() { }


  override didBlur() {
    super.didBlur();
    if (!this.validateOnBlur) {
      return;
    }
    if (this.isValid) {
      this.checkingValidity.emit(this);
    }
  }


  keyUp(evt){
    this.keyup.emit();
  }
}

export enum InputOptions {
  TEL = 'tel',
  URL = 'url',
  DATE = 'date',
  TIME = 'time',
  TEXT = 'text',
  EMAIL = 'email',
  NUMBER = 'number',
  SELECT = 'select',
  CONTENT = 'content',
  CURRENCY = 'currency',
  PERCENT = 'percent',
  CHECKBOX = 'checkbox',
  BUTTON = 'button',
  BUTTONARRAY = 'button-array',
  TEXTARRAY = 'text-array',
  BOOLEAN = 'boolean',
}

